<template>
  <div id="app">
    <div class="columns is-hidden-desktop">
      <div class="column">
        <div class="mobile-logo">
          <router-link to="/"><img src="/img/logos/Tekstur-Logo-Dark-No-Tagline.svg" alt="Tekstur Logo" width="200"></router-link>
          <p class="caps"><small>Visual Identity Guide</small></p>
        </div>
      </div>
      <div class="column">
        <Slide right>
          <h3 class="white">Menu</h3>
            <Nav/>
            <ul class="menu-list">
              <li v-if="isLoggedIn">
                <a @click="triggerNetlifyIdentityAction('logout')">Log Out</a>
              </li>
              <li v-else>
                <a @click="triggerNetlifyIdentityAction('login')">Log In</a>
              </li>
            </ul>
        </Slide>
      </div>
    </div>
    <div class="columns">
      <div class="column is-hidden-touch" id="nav">
        <div class="sticky">
          <router-link to="/" class="nav-pad"><img src="/img/logos/Tekstur-Logo-Light-No-Tagline.svg" alt="Tekstur Logo" width="200"></router-link>
          <aside class="menu">
            <p class="menu-label nav-pad tagline">Visual Identity Guide</p>
            <ul class="menu-list" v-if="isLoggedIn">
              <Nav/>
            </ul>
            <ul class="menu-list logout">
              <!-- <li v-if="isLoggedIn" style="padding: 0.5em 0.75em;">Logged in as <strong>{{user.email}}</strong></li> -->
              <li v-if="isLoggedIn">
                <a @click="triggerNetlifyIdentityAction('logout')">Log Out</a>
              </li>
              <li v-else>
                <a @click="triggerNetlifyIdentityAction('login')">Log In</a>
              </li>
            </ul>
          </aside>
        </div>
      </div>
      <div class="column is-full-mobile is-four-fifths-desktop" id="main">
        <div v-if="isLoggedIn">
          <router-view></router-view>
        </div>
        <div v-else>
          <p>You are currently logged out, please click the button below to log into Tekstur Brand Guide:</p>
          <p>
            <button class="button" @click="triggerNetlifyIdentityAction('login')">Log In</button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from '@/components/Nav.vue'
import netlifyIdentity from 'netlify-identity-widget'
import { mapGetters, mapActions } from 'vuex'
import { Slide } from 'vue-burger-menu'

netlifyIdentity.init({
  APIUrl: 'https://brand.tekstur.com/.netlify/identity',
  logo: true // you can try false and see what happens
})

// const user = netlifyIdentity.currentUser()

export default {
  components: {
    Nav,
    Slide
  },
  computed: {
    ...mapGetters('user', {
      isLoggedIn: 'getUserStatus',
      user: 'getUser'
    }),
    username () {
      return this.user ? this.user.username : ', there!'
    }
  },
  data () {
    return {}
  },
  mounted () {
    netlifyIdentity.on('signup', () => this.$router.push({ name: 'home' }))
    netlifyIdentity.on('close', () => this.$router.push({ name: 'home' }))
  },
  methods: {
    ...mapActions('user', {
      updateUser: 'updateUser'
    }),
    triggerNetlifyIdentityAction (action) {
      if (action === 'login' || action === 'signup') {
        netlifyIdentity.open(action)
        netlifyIdentity.on(action, user => {
          netlifyIdentity.close()
          let currentUser = {
            username: user.user_metadata.full_name,
            email: user.email,
            access_token: user.token.access_token,
            expires_at: user.token.expires_at,
            refresh_token: user.token.refresh_token,
            token_type: user.token.token_type
          }
          this.updateUser({
            currentUser: currentUser
          })
          this.$router.push({ name: 'home' })
        })
      } else if (action === 'logout') {
        this.updateUser({
          currentUser: null
        })
        netlifyIdentity.logout()
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style lang="scss">
// https://buefy.github.io/documentation/customization
// Import Bulma's core
@import url('https://fonts.googleapis.com/css?family=Raleway:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i&subset=latin-ext');
$blue: #356E7B;
$lightblue: #63CDE5;
$darkblue: #1B3940;
$tan: #FFB26E;
$gray: #231f20;
$darkgray: #313131;
$mediumgray: #555555;
$lightgray: #eeeeee;

body {
  color: $darkgray;
  font-family: 'Raleway', sans-serif;
  font-weight: 500;
  font-variant-numeric: lining-nums;
  -moz-font-feature-settings: 'tnum';
  -webkit-font-feature-settings: 'tnum';
  font-feature-settings: 'tnum';
}

.blue {
  color: $blue;
}
.lightblue {
  color: $lightblue;
}
.darkblue {
  color: $darkblue;
}
.tan {
  color: $tan;
}
.gray {
  color: $gray;
}
.darkgray {
  color: $darkgray;
}
.mediumgray {
  color: $mediumgray;
}
.lightgray {
  color: $lightgray;
}
.white {
  color: #fff;
}

@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: $blue;
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);
$black: #111111;
$white: #ffffff;
$body-line-height: 1.6;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "twitter": (
    $twitter,
    $twitter-invert
  )
);

$menu-item-color: $white;
$menu-label-color: $white;
// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

$side-padding: 35px;

#app {
  padding-right: $side-padding;
  margin-bottom: 0;
  z-index: 1;
  .home-button {
    opacity: 0.75;
    background: $white;
    position: fixed;
    bottom: 0;
    right: 0;
    padding: $side-padding;
    z-index: 9999;
    // font-size: 1px;
  }
}

#main {
  padding-top: $side-padding;
  padding-left: $side-padding;
  padding-bottom: 1400px;
}

#nav {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  background: $black;
  padding-top: $side-padding;
  padding-left: $side-padding;
  height: calc(100vh + 12px);
  .logout {
    color: $white;
    position: absolute;
    bottom: $side-padding - 12px;
    left: $side-padding;
    // bottom: 0;
    // left: 0;
    font-size: 12px;
    strong {
      color: $white;
    }
  }
  // .nav-pad {
  //   padding: 0.5em 0.75em;
  // }
  // .sticky {
  //   padding-top: 15px;
  // }
}
.menu-list a {
  font-family: 'Raleway', sans-serif;
  text-transform: uppercase;
  font-weight: 700;
}
.menu-list a.router-link-exact-active {
  color: $lightgray;
  background-color: $darkgray;
  &::before {
    content: '> '
  }
}
p {
  // padding-top: 15px;
  padding-bottom: 15px;
}
.button {
  margin-bottom: 25px;
}
h1, h2, h3, h4, h5, h6 {
    color: $black;
    font-weight: 900;
    text-transform: uppercase;
    small {
        color: $mediumgray;
    }
}

h1 {
    font-size: 48px;
    small {
        font-size: calc(48px / 2);
    }
}
h2 {
    font-size: 40px;
    small {
        font-size: calc(40px / 2);
    }
}
h3 {
    font-size: 32px;
    small {
        font-size: calc(32px / 2);
    }
}
h4 {
    font-size: 24px;
    small {
        font-size: calc(24px / 2);
    }
}
h5 {
    font-size: 20px;
    small {
        font-size: calc(20px / 2);
    }
}
h6 {
    font-size: 18px;
    small {
        font-size: calc(18px / 2);
    }
}
p {
    font-size: 18px;
    font-weight: 500;
}
blockquote {
  font-family: 'Raleway', sans-serif;
  font-weight: 500;
  border-left: 4px solid $lightgray;
  margin: 25px 0;
  padding: 10px 10px;
}
.logo {
    padding-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 25px;
    // margin: 0 auto;
}
.logo-height {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}
.graybg {
    background: $gray;
}
.bluebg {
    background: $blue;
}
.whitebg {
    background: $white;
    border: 2px solid $lightgray;
}
.lightgraybg {
    background: $lightgray;
}

.v-center {

  display: flex;
  justify-content: center;
  align-items: center;
}
.caps {
  text-transform: uppercase;
  padding-bottom: 0;
}
.mobile-logo {
  padding: 15px;
}
* {
  font-family: 'Raleway', Arial, Helvetica, sans-serif;
  font-variant-numeric: lining-nums;
  -moz-font-feature-settings: 'tnum';
  -webkit-font-feature-settings: 'tnum';
  font-feature-settings: 'tnum';
}
.card-footer-item {
  // font-family: 'Raleway', sans-serif;
  font-size: 14px !important;
  font-weight: 900 !important;
  text-transform: uppercase !important;
}
.bm-item-list > * {
  display: block;
}
.tagline {
  padding-left: 10px;
}
</style>
